module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersWidgetLinks":{"deselect":"- Vyberte -"}},"en":{"CatalogFiltersWidgetLinks":{"deselect":"- Choose -"}}}')
  delete Component.options._Ctor
}
